import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PasswordResetSuccess.css';

const PasswordResetSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToSignIn = () => {
    navigate('/login');
  };

  return (
    <div className="password-reset-success-container">
      <div className="password-reset-success-content">
        {/* Success Icon with Green Glow */}
        <div className="success-icon-wrapper">
          <div className="success-icon-container">
            <svg 
              width="56" 
              height="56" 
              viewBox="0 0 56 56" 
              fill="none"
              className="success-icon"
            >
              <path 
                d="M46.667 14L21 39.667L9.333 28" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Success Heading */}
        <h1 className="success-heading">
          Password Reset Successful!
        </h1>

        {/* Success Message */}
        <p className="success-message">
          Your password has been reset successfully. You can now sign in with your new password.
        </p>

        {/* Go to Sign In Button */}
        <button 
          className="signin-redirect-button"
          onClick={handleGoToSignIn}
        >
          Go to Sign In
        </button>
      </div>
    </div>
  );
};

export default PasswordResetSuccess;